/* eslint-disable react/prop-types */
const CategorySideBar = ({ subcategories, onCategorySelect, activeCategoryId }) => {
  return (
    <aside>
      <ul>
        {subcategories.map((subcategory) => (
          <li key={subcategory.id}>
            <button
              className={`p-2 w-full text-xl text-primary-studio font-secondary hover:bg-gray-300 text-start ${activeCategoryId === String(subcategory.id) ? 'bg-gray-300' : ''}`}
              onClick={() => onCategorySelect(subcategory.id)}
            >
              {subcategory.name}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default CategorySideBar;